import axios from "axios";
import * as config from "../api/config"

export const GET = async (path, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }
  const Url = config.API_URL + path;
  try {
    const response = await axios.get(Url, {
      headers: headers,
      withCredentials: true
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const POST = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  const Url = config.API_URL + path;
  try {
    const response = await axios.post(Url, payload, {
      headers: headers,
      withCredentials: true
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const PUT = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  const Url = config.API_URL + path;
  try {
    const response = await axios.put(Url, payload, {
      headers: headers,
      withCredentials: true
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const DELETE = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "application/json",
    };
  }

  const Url = config.API_URL + path;
  try {
    const response = await axios.delete(
      Url,
      {
        headers: headers,
        withCredentials: true
      },
      payload
    );
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};

export const UPLOAD = async (path, payload, token) => {
  var headers;
  if (token) {
    headers = {
     "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    };
  } else {
    headers = {
      "Content-Type": "multipart/form-data",
    };
  }

  const Url = config.API_URL + path;
  try {
    const response = await axios.post(Url, payload, {
      headers: headers,
      withCredentials: true
    });
    return response;
  } catch (error) {
    if (error?.response?.status === 401) {
      //window.history.pushState({}, "", "/");
      const navEvent = new Event("Unauth");
      window.dispatchEvent(navEvent);
    }
    return error;
  }
};
